import React, { useEffect, useRef, useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { TextValidator } from "react-material-ui-form-validator";
import useOnclickOutside from "react-cool-onclickoutside";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export default function AutoCompleteAddress(props) {
  let textInput = useRef(null);
  let sameAddress = props.values.sameAddress;

  const [addressField, setNewAddress] = useState(
    props.values.modemDeliveryAddress
  );
  const [value, setValue] = useState(props.values.modemDeliveryAddress || "");
  const [addressSelected, setAddressSelected] = useState(false); // Track if the address was selected
  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, clear suggestions (if necessary)
  });

  const handleInput = (e) => {
    // Update the value of the input element
    setValue(e.target.value);
    setAddressSelected(false); // Mark as not selected if typing manually
  };

  // Handle when the input field loses focus (blur event)
  const handleBlur = () => {
    if (!addressSelected) {
      setValue(""); // Clear the input if no address was selected
    }
  };

  useEffect(() => {
    if (sameAddress && props.type === "postal") {
      setValue(props.values.address);
      props.setAddresses(props.values.address, "postal");
    }
  }, [sameAddress]);

  // Ensure AddressFinder widget is initialized on the client-side after mounting
  useEffect(() => {
    if (textInput.current && window.AddressFinder) {
      const widget = new window.AddressFinder.Widget(
        textInput.current,
        "V3YULPXNHT49F8BCE7DG",
        "NZ",
        {
          manual_style: true,
          empty_content: "",
          empty_class: "af_empty",
          show_addresses: true,
          show_locations: false,
          address_params: {
            street: 1,
            city: 1,
            region: 1,
            post_box: 0,
          },
        }
      );

      widget.on("result:select", function (fullAddress, metaData) {
        setValue(fullAddress);
        props.setAddresses(fullAddress, props.type);
        setNewAddress(fullAddress);
        setAddressSelected(true); // Mark as selected when an address is chosen
      });
    }
  }, [textInput]);

  return (
    <React.Fragment>
      {props.type === "modem" ? (
        // <TextValidator
        //   style={{ marginTop: "0" }}
        //   placeholder="Modem delivery address (If different from above)"
        //   autoComplete="off"
        //   inputRef={textInput}
        //   fullWidth
        //   name="address"
        //   type="text"
        //   variant="standard"
        //   margin="normal"
        //   value={value}
        //   onChange={handleInput}
        //   onBlur={handleBlur} // Check if the address was selected on blur
        // />
        <React.Fragment>
          {props.type === "modem" && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.sameModemAddress}
                  onChange={props.handleChange("sameModemAddress")}
                  name="sameModemAddress"
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                />
              }
              label="Modem delivery address is the same as your installation address."
            />
          )}
          <TextValidator
            style={{ marginTop: "0" }}
            placeholder="Enter delivery address if different from above*"
            helpertext="This is where important communication will be delivered to"
            autoComplete="new-password" // Disable browser auto-suggest
            inputRef={textInput}
            fullWidth
            validators={["required"]}
            errorMessages={["Please enter your modem address"]}
            required
            name="address"
            type="text"
            variant="outlined"
            margin="normal"
            value={value}
            onChange={handleInput}
            onBlur={handleBlur} // Check if the address was selected on blur
            className="field-item__input field-item__input--postal"
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {props.type === "postal" && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.values.sameAddress}
                  onChange={props.handleChange("sameAddress")}
                  name="sameAddress"
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                />
              }
              label="Postal address is the same as your installation address"
            />
          )}
          <TextValidator
            style={{ marginTop: "0" }}
            placeholder="Enter Postal Address"
            helpertext="This is where important communication will be delivered to"
            autoComplete="new-password" // Disable browser auto-suggest
            inputRef={textInput}
            fullWidth
            validators={["required"]}
            errorMessages={["Please enter your postal address"]}
            required
            name="address"
            type="text"
            variant="outlined"
            margin="normal"
            value={value}
            onChange={handleInput}
            onBlur={handleBlur}
            className="field-item__input field-item__input--postal"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}